import Decimal from "decimal.js";
Decimal.set({ precision: 20, rounding: Decimal.ROUND_HALF_UP });
export function toDecimal(v) {
    return new Decimal(v);
}
/** Round to 2dp (MYR sen precision) using banker's half-up. */
export function round2(v) {
    return toDecimal(v).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}
/** "12,843.55": grouped thousands, always 2dp — the one way every app shows an amount. */
export function fmtAmount(v) {
    return round2(v).toNumber().toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
/** Format MYR amount: 12843.5 → "RM 12,843.50". */
export function formatMYR(v) {
    return `RM ${fmtAmount(v)}`;
}
/** JSON-safe string form of a Decimal, always 2dp. */
export function money(v) {
    return round2(v).toFixed(2);
}
//# sourceMappingURL=money.js.map